<!-- App Header -->
<app-not-refresh-appbar parentLink="/profile/me-page" [rootLevel]="1">
  {{ 'your_change_password' | translate }}
</app-not-refresh-appbar>

<div class="main__wrapper">
  <h4 class="text-center">{{ 'changePasswordPage' | translate }}</h4>

  <form>
    <div class="container">
      
      <!-- Old Password -->
      <div class="row password-eye">
        <div class="col-1"></div>
        <div class="col-10 position-relative">
          <input
            id="password"
            class="form-control inputFiled"
            [type]="passwordType"
            placeholder="{{ 'oldPassword' | translate }}"
            [(ngModel)]="password"
            [ngModelOptions]="{ standalone: true }"
            (keyup.enter)="enter($event)"
            (keyup)="checkPassword()" />

          <span class="text-eye">
            <a (click)="showPassword(!showPass)">
              <ion-icon [attr.name]="showPass ? 'eye' : 'eye-off'"></ion-icon>
            </a>
          </span>

          <p class="passError1 ml-5"></p>
        </div>
        <div class="col-1"></div>
      </div>

      <!-- Password Hints -->
      <div class="row mx-4">
        <h5>{{ 'set_password_dec1' | translate }}</h5>
        <h5>{{ 'forget_password_dec2' | translate }}</h5>
      </div>

      <!-- New Password -->
      <div class="row password-eye">
        <div class="col-1"></div>
        <div class="col-10 position-relative">
          <input
            class="form-control inputFiled"
            [type]="passwordType"
            placeholder="{{ 'newPasswordHint' | translate }}"
            [(ngModel)]="newPassword"
            [ngModelOptions]="{ standalone: true }"
            (keyup.enter)="enter($event)"
            (keyup)="checkNewPassword()" />

          <span class="text-eye">
            <a (click)="showPassword(!showPass)">
              <ion-icon [attr.name]="showPass ? 'eye' : 'eye-off'"></ion-icon>
            </a>
          </span>

          <p class="passError2 ml-5"></p>
        </div>
        <div class="col-1"></div>
      </div>

      <!-- Confirm Password -->
      <div class="row password-eye mt-3">
        <div class="col-1"></div>
        <div class="col-10 position-relative">
          <input
            class="form-control inputFiled"
            [type]="passwordType"
            placeholder="{{ 'regconfirmpasswordHint' | translate }}"
            [(ngModel)]="confirmPassword"
            [ngModelOptions]="{ standalone: true }"
            (keyup.enter)="enter($event)"
            (keyup)="checkConfirmPassword()" />

          <span class="text-eye">
            <a (click)="showPassword(!showPass)">
              <ion-icon [attr.name]="showPass ? 'eye' : 'eye-off'"></ion-icon>
            </a>
          </span>

          <p class="passError3 ml-5"></p>
        </div>
        <div class="col-1"></div>
      </div>

      <!-- Loading Spinner -->
      <div
        *ngIf="loadingSubmiting"
        class="mt-2 d-flex justify-content-center position-relative bg-danger">
        <ngx-spinner
          name="loadingSubmiting"
          size="medium"
          color="grey"
          type="ball-spin-clockwise"
          [fullScreen]="false">
        </ngx-spinner>
      </div>

      <!-- Submit Button -->
      <button
        *ngIf="!loadingSubmiting"
        type="button"
        class="btn login-button"
        (click)="changePassword()">
        {{ 'account_change' | translate }}
      </button>
    </div>
  </form>
</div>
